import { render } from "./FormSubmissions.vue?vue&type=template&id=44933125&ts=true"
import script from "./FormSubmissions.vue?vue&type=script&lang=ts"
export * from "./FormSubmissions.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__